module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAATpJREFUOE9jZIAC6YQnCYwMfycxMjDxwsSw0f///3/CyMiQ+3iB3AaQPCOIkEh4rsDK8Oc+A8N/IAQL4Qf//3/5wsgr+2GB4AdGoM0GjAz/FjEyMOr+B2rTlmNl4OVkwmrA07d/GB6/+Qu2AmjV5f8MTHGMMvGPngAdIgEUZQbpujpNmoGPE7srTtz8yRDa8RpiONAERsb/mxhlEx7/B9kM0yIjwswgI8KC1QXXHv1i+PQNpBqkH4wvYhhAyPswebgBbz//hRhJBnjz8e93xrm7PqF4gVhzQLb++sP4AsULfFyQkID5E59hWMPgCjAGQM7RzX5K0CFYDdjRJA7W6FH3kjwDCOpCUkC9aERPSMS6Au4CcFJmZJQEasSeAXCb+JeR4f8WaGb6PwFoogCxtoPUMTH8f/CPgakBAPCxj5BNKsFjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/apiWord.png
// module id = IyKT
// module chunks = 11